/** Map one shared output intent to settings accepted by every target model. */
export function buildComparisonTargets(profiles, selectedProviders, ratio, quality) {
    const selected = new Set(selectedProviders);
    return profiles
        .filter(profile => profile.configured && selected.has(profile.provider))
        .map(profile => {
        const targetRatio = profile.ratioOptions.some(option => option.value === ratio) ? ratio : profile.defaultRatio;
        const targetQuality = profile.qualityOptions.some(option => option.value === quality) ? quality : profile.defaultQuality;
        return {
            profile,
            ratio: targetRatio,
            quality: targetQuality,
            adjusted: targetRatio !== ratio || targetQuality !== quality,
        };
    });
}
/** Start with two models, not every configured API, to avoid surprise spend. */
export function initialComparisonProviders(profiles, activeProvider) {
    const configured = profiles.filter(profile => profile.configured);
    const active = configured.find(profile => profile.provider === activeProvider);
    const ordered = active === undefined
        ? configured
        : [active, ...configured.filter(profile => profile.provider !== activeProvider)];
    return ordered.slice(0, 2).map(profile => profile.provider);
}
//# sourceMappingURL=multi-model-compare.js.map